import { useEffect, useRef, useState } from "react";

export function useIsScrollingDown() {
  // https://stackoverflow.com/questions/57088861/react-setstate-hook-from-scroll-event-listener

  const prevScrollRef = useRef(0);
  const scrollDownCounterRef = useRef(0);

  const [scrollingUp, setScrollingUp] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      const scrollingDown = prevScrollRef.current < currentScrollY;
      const overScrollBottom =
        currentScrollY >= document.body.scrollHeight - window.innerHeight;

      if (currentScrollY < 50) {
        if (!scrollingUp) {
          setScrollingUp(true);
        }
        return;
      }

      if (prevScrollRef.current > currentScrollY && currentScrollY > 0) {
        scrollDownCounterRef.current = 0;
        if (!scrollingUp && !overScrollBottom) {
          setScrollingUp(true);
        }
      } else if (scrollingDown) {
        scrollDownCounterRef.current += 1;
        if (scrollDownCounterRef.current > 5) {
          if (scrollingUp) {
            setScrollingUp(false);
          }
        }
      }
      prevScrollRef.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollingUp]);

  return scrollingUp;
}

export function useInterval(callback, delay) {
  const callbackRef = useRef();
  const intervalId = useRef();

  function startInterval() {
    intervalId.current = setInterval(() => {
      callbackRef.current();
    }, delay);
  }

  useEffect(() => {
    callbackRef.current = callback;
  });

  // Originally this hook automatically started the interval, which we don't really want
  // in the carousel (the only place the hook is currently used) as we only want to start
  // the things up once everything's loaded
  // useEffect(() => {
  //   startInterval()
  //   return () => clearInterval(intervalId.current)
  //   // eslint-disable-next-line
  // }, [])

  return {
    clearInterval: () => {
      clearInterval(intervalId.current);
    },
    startInterval,
  };
}

export function useForm(initialValue) {
  const [formData, setFormData] = useState(initialValue);
  const [formErrors, setFormErrors] = useState(initialValue);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormErrors({ ...formErrors, [e.target.name]: "" });
  };

  return {
    formData,
    handleChange,
    setFormErrors,
    setFormData,
    formErrors,
  };
}
